export default class {
  load(url, callback, onError, withCredentials) {
    try {
      const req = new XMLHttpRequest();
      req.withCredentials = Boolean(withCredentials);
      req.open('GET', url, true);
      req.onreadystatechange = () => {
        if (req.readyState === 4) {
          if (req.status === 200) {
            callback(req.responseText);
          } else {
            onError(`Error loading: ${url}`);
          }
        }
      };
      req.send(null);
    } catch {
      onError(`Error loading: ${url}`);
    }
  }
}
